<template>
<!--我的订单-->
  <div class="orders">
      <div class="titleWrap">
        <p class="titleName">积分规则介绍</p>
        <router-link to="/jifen" class="pull-right">返回</router-link>
      </div>
      <ul class="noticeout">
        <li>
          <p class="noticeTitle">1.什么是积分</p>
          <p class="noticeInfor">积分是勤博官方虚拟商品的预付费凭证，只可用于购买勤博官方网站及App上的各种虚拟产品和增值服务，积分在勤博官网运营期间长期有效，但用户无法体现或转赠他人。</p>
        </li>
        <li>
          <p class="noticeTitle">2.积分的获取</p>
          <p class="noticeInfor">用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。</p>
        </li>
        <li>
          <p class="noticeTitle">3.积分的使用范围</p>
          <p class="noticeInfor">用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。用户可以通过注册勤博账户做任务等方式获得。</p>
        </li>
      </ul>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .titleWrap {
    height: 40px;
    font-size: 18px;
    padding-bottom: 20px;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 20px;
    color: #957960;
    .titleName {
      float: left;
      line-height: 24px;
      border-bottom: 3px solid #957960;
      padding-bottom: 13px;
    }
    a{
      font-size: 14px;
      color: #957960;
    }
  }
  .noticeout li {
    border-bottom: 1px solid #E1E1E1;
    padding: 20px 0;
    .noticeTitle, .noticeInfor {
      /*font-size: 16px;*/
      color: #333;
      line-height: 24px;
    }
    .noticeTitle {
      margin-bottom: 10px;
    }

  }
  li:last-child{
    border-bottom: none;
  }
</style>
<script type="text/ecmascript-6">
  import centers from '../template/center'
    export default {
        name: 'orderdetail',
        props: {},
        data() {
            return {
            };
        },
        methods: {},
        created() {

        },
        components: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/rule.vue